import type {
  DataFetchParams,
  DataFetchResponse,
  FilterOptionsParams,
  DynamicFilterOptionsPage,
} from '@/components/DataTable';
import {
  listPersonalBrowserAiToolsDataTable,
  getPersonalBrowserAiToolsFilterOptions,
} from '@kirin/api-client/api/shadow-ai';
import type {
  PersonalBrowserAiToolsFilterOptionField,
  PersonalBrowserAiToolsSortField,
} from '@kirin/api-client/contracts/account-shadow-ai-browser-tools';
import type { BrowserAiToolListItem } from '@kirin/api-client/contracts/shadow-ai-browser-tools';
import { apiClient } from '@/lib/api-client';

export async function fetchPersonalBrowserTools(
  params: DataFetchParams,
  signal?: AbortSignal
): Promise<DataFetchResponse<BrowserAiToolListItem>> {
  const sortField = params.sort?.field as
    | PersonalBrowserAiToolsSortField
    | undefined;
  const response = await listPersonalBrowserAiToolsDataTable(
    apiClient,
    {
      page: params.pagination.pageIndex + 1,
      limit: params.pagination.pageSize,
      filters: params.filters,
      sortBy: sortField,
      sortOrder: params.sort?.order,
      search: params.search,
    },
    { signal }
  );

  return {
    // Rows are the org shape minus Users; the dropped userCount is never read.
    data: response.data as BrowserAiToolListItem[],
    pagination: response.pagination,
    meta: {
      activeFilters: response.meta?.activeFilters ?? [],
      search: response.meta?.search,
    },
  };
}

export async function fetchPersonalBrowserToolsFilterOptions(
  field: PersonalBrowserAiToolsFilterOptionField,
  params: FilterOptionsParams
): Promise<DynamicFilterOptionsPage> {
  const response = await getPersonalBrowserAiToolsFilterOptions(apiClient, {
    field,
    search: params.search,
    limit: params.limit,
    offset: params.offset,
  });

  return {
    options: response.options,
    total: response.pagination.total,
    nextOffset: response.pagination.nextOffset ?? null,
    hasMore: response.pagination.hasMore,
  };
}
